import { REMOVE_FROM_CART } from './types';

/**
 * @param {Object} item containing the id of the item, and the item type.
 * Ex: 'application' type or 'permit' type
 * @param {Boolean} isDrawerOpen Is the Cart Drawer open?
 * @returns {Object} The action object for the change.
 */
export default (item, isDrawerOpen) => ({
  type: REMOVE_FROM_CART,
  payload: {
    item,
    isDrawerOpen,
  },
});
